import { api } from '$utils/apiRequester'

export const LOAD_USER_REQUEST = 'LOAD_USER_REQUEST'
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS'
export const LOAD_USER_FAILURE = 'LOAD_USER_FAILURE'

export const GET_USER_REQUEST = 'GET_USER_REQUEST'
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const GET_USER_FAILURE = 'GET_USER_FAILURE'

export const GET_USER_CHANNELS_REQUEST = 'GET_USER_CHANNELS_REQUEST'
export const GET_USER_CHANNELS_SUCCESS = 'GET_USER_CHANNELS_SUCCESS'
export const GET_USER_CHANNELS_FAILURE = 'GET_USER_CHANNELS_FAILURE'

export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'

export const UPDATE_USER_BAN_REQUEST = 'UPDATE_USER_BAN_REQUEST'
export const UPDATE_USER_BAN_SUCCESS = 'UPDATE_USER_BAN_SUCCESS'
export const UPDATE_USER_BAN_FAILURE = 'UPDATE_USER_BAN_FAILURE'

export const UPDATE_USER_ACCEPT_EULA_REQUEST = 'UPDATE_USER_ACCEPT_EULA_REQUEST'
export const UPDATE_USER_ACCEPT_EULA_SUCCESS = 'UPDATE_USER_ACCEPT_EULA_SUCCESS'
export const UPDATE_USER_ACCEPT_EULA_FAILURE = 'UPDATE_USER_ACCEPT_EULA_FAILURE'

export const loadUser = extraFields => ({
  types: [LOAD_USER_REQUEST, LOAD_USER_SUCCESS, LOAD_USER_FAILURE],
  promise: () => api('ulule').me(extraFields)
})

export const updateUser = (data = {}) => ({
  type: UPDATE_USER_SUCCESS,
  data
})

export const getUser = (id, isAuthenticated, extraFields = []) => {
  const fields = extraFields.join(',')

  return {
    types: [GET_USER_REQUEST, GET_USER_SUCCESS, GET_USER_FAILURE],
    promise: () =>
      api('ulule').get(`/users/${id}${extraFields && extraFields.length > 0 ? `?extra_fields=${fields}` : ''}`, {
        withAccessToken: isAuthenticated
      })
  }
}

export const banUser = id => ({
  types: [UPDATE_USER_BAN_REQUEST, UPDATE_USER_BAN_SUCCESS, UPDATE_USER_BAN_FAILURE],
  promise: () =>
    api('ulule').post(`/users/${id}/ban`, {
      withAccessToken: true
    })
})

export const getUserChannels = (id, limit = 4, next) => ({
  types: [GET_USER_CHANNELS_REQUEST, GET_USER_CHANNELS_SUCCESS, GET_USER_CHANNELS_FAILURE],
  promise: () => api('ulule').get(`/users/${id}/channels${next ? `?next=${next}` : `?limit=${limit}`}`)
})
